import Axios from 'axios';
import { BASE_URL } from '../services/ApiService/ApiConfig';
const API_URL = BASE_URL

if (!API_URL) {
    console.error('API_URL is not defined. Please set the BACKEND_URL environment variable.');
}

const defaultApi = Axios.create({
    baseURL: API_URL
});

defaultApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwt')?.replaceAll('"', '');
    const isFormData = config.data instanceof FormData;

    const baseHeaders = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };

    // Solo forzar JSON si no es FormData y no se seteo otro Content-Type
    if (!isFormData && !config.headers?.['Content-Type']) {
        baseHeaders['Content-Type'] = 'application/json';
    }

    config.headers = { ...baseHeaders, ...config.headers };
    return config;
});

export default defaultApi;
